export const CHECKOUT_URL = 'https://sushi-facil-en-casa.impultienda.ar/checkout'

export const BRAND = 'Sushi Fácil en Casa™'

export const TAGLINE = 'Sushi hermoso. Incluso cuando crees que no puedes hacerlo.'

export const MAIN_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/ni21yAg4PEMaJv78BSYzEL/ChatGPT_Image_21_sept_2026,_12_20_02.png'

export const MOCKUP_ALT =
  'El sistema completo Sushi Fácil en Casa — ebook principal y los 3 bonos mostrados en laptop, tablet y celular'

/* ---------------------------------------------------------------- Hero */

export const HERO_KICKER = 'La Biblia del Sabor'

export const HERO_HEADLINE =
  'Sushi espectacular en casa. Sin esterilla. Sin rolls difíciles. Sin técnica.'

export const HERO_BODY: string[] = [
  'Todo lo que necesitas en un PDF listo para cocinar hoy.',
]

export const HERO_EMPHASIS =
  '15 minutos entre “¿qué hago?” y algo espectacular en la mesa.'

export const HERO_SUB =
  'SUSHI FÁCIL EN CASA™ Sistema Completo — 90 páginas paso a paso: Balls, Bake, Donuts, Crispy, Cups, Tacos y Cubetera.'

export const CTA_LABEL = 'Quiero acceso a Sushi Fácil en Casa ahora →'

/** Ventana de lanzamiento, en segundos, desde que carga la página. */
export const LAUNCH_WINDOW_SECONDS = 5 * 3600 + 30 * 60 + 5

export const journeySteps: string[] = [
  'Balls',
  'Bake',
  'Donuts',
  'Crispy',
  'Cups',
  'Tacos',
  'Cubetera',
]

/* --------------------------------------------------------------- Proof */

export type Stat = { value: string; label: string }

export const stats: Stat[] = [
  { value: '+2,500', label: 'Cocineros caseros' },
  { value: '40+', label: 'Recetas sin enrollar' },
  { value: '3', label: 'Bonos incluidos' },
  { value: '4.9/5', label: 'Calificación promedio' },
]

export type Testimonial = {
  initials: string
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'VG',
    quote:
      'Dejé de pedir sushi. Hago recetas espectaculares en 15 minutos y ahorro $200+ al mes.',
    name: 'Valentina G.',
    role: 'Creadora de contenido',
  },
  {
    initials: 'CR',
    quote:
      'Mi familia come sushi de verdad ahora. Ya no pasamos 20 minutos buscando en internet qué hacer.',
    name: 'Carlos R.',
    role: 'Padre de dos hijos',
  },
  {
    initials: 'AS',
    quote:
      'Cocinar sushi no es un proyecto complicado. Todo es directo y realmente delicioso.',
    name: 'Andrea S.',
    role: 'Cocinera casera',
  },
]

/* ---------------------------------------------------------------- Pain */

export const PAIN_HEADLINE =
  '¿Cuántas veces más vas a pedir sushi por delivery?'

export const PAIN_BODY: string[] = [
  'Querés comer sushi en casa. Pero cada vez que lo intentás, la receta asume que tenés esterilla, técnica y toda la tarde libre.',
  'Ves videos larguísimos donde enrollan sin parar, lo intentás una vez, se te desarma, y no volvés a intentarlo.',
]

export const PAIN_EMPHASIS =
  'El problema no es que no sepas cocinar. Es que nadie te mostró los formatos de sushi que no se enrollan.'

export const PAIN_CLOSING =
  '¿Y si pudieras armar algo espectacular en menos tiempo del que tarda el delivery?'

export const painLines: string[] = [
  'Crees que hacer sushi requiere técnica profesional',
  'Crees que necesitas esterilla y equipamiento especial',
  'Ves videos largos donde enrollan sin parar',
  'Lo intentas una vez, se desmorona, nunca más lo intentas',
  'Terminas pidiendo por delivery ($15–25 por orden)',
  'Siempre comes los mismos 3 sabores',
  'Gastas $3,000+ al año en sushi que podrías hacer en casa',
]

/* -------------------------------------------------------------- System */

export const REVEAL_TITLE = 'Sushi Fácil en Casa™ — Sistema completo'

export const REVEAL_SUB =
  'Ebook principal de 90 páginas. 7 formatos visuales, 40+ recetas sin enrollar y un sistema de combinaciones paso a paso.'

export type Format = {
  name: string
  line: string
  image: string
}

export const formats: Format[] = [
  {
    name: 'Balls',
    line: 'Con papel film',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ef737c6b-8ddb-4dac-b24f-ae1d8e2a61ec.jpg',
  },
  {
    name: 'Bake',
    line: 'Tipo torta',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/16aed6f0-6a2e-4e69-b9ea-b6815c1066a4.jpg',
  },
  {
    name: 'Donuts',
    line: 'Visual wow',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0eb6aca8-3133-4860-b6cb-ec64f830608e.jpg',
  },
  {
    name: 'Crispy',
    line: 'Dorados',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dffc88a5-e4af-4758-a3d4-69fe8fb63d44.jpg',
  },
  {
    name: 'Cups',
    line: 'En vasitos',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4f7471e7-4e8d-4019-bd83-f29506d241fb.jpg',
  },
  {
    name: 'Tacos',
    line: 'Foldeados',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8aba5edf-5936-46db-8de9-e1b1259a9bdc.jpg',
  },
  {
    name: 'Cubetera',
    line: 'Bocados con film',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/345d3456-0fa6-4550-80a1-f24cca2afba2.jpg',
  },
]

export const systemIncludes: string[] = [
  'Cómo hacer sushi sin esterilla',
  'Ingredientes básicos (no caros)',
  '7 formatos visuales: Balls, Bake, Donuts, Crispy, Cups, Tacos y Cubetera',
  '40+ recetas sin enrollar',
  'Sistema de combinaciones paso a paso',
  'Opciones cocidas, económicas y premium',
  'Técnica de presentación para que se vea premium',
]

export const INCLUDES_KICKER =
  'Sushi hermoso. Incluso cuando crees que no puedes hacerlo.'

/* ------------------------------------------------------------ Carousel */

export type EbookPage = { image: string; caption: string }

export const CAROUSEL_TITLE = 'Mira todo lo que vas a poder preparar'

export const CAROUSEL_SUB =
  'No tienes que imaginar qué encontrarás dentro. Mira algunas de las recetas, técnicas y preparaciones que tendrás paso a paso.'

export const CAROUSEL_FOOTNOTE =
  'Recetas visuales, instrucciones claras y formatos que parecen difíciles, pero están pensados para poder hacerlos en casa.'

export const ebookPages: EbookPage[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/8kSAYZsgGTezRiz4zKTY1j/b4b3c0b8-f82f-4797-b94a-11e0344edfa7.png',
    caption: 'Portada del ebook',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/m39yJpeTWzUGNmpFZjRy8f/0cc99a34-cc14-486b-a4ce-4bf90774d4f7.png',
    caption: 'Sushi Balls / Temari',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/7Mqtbsy1R2SK93RZWS3SDW/a96e3ee8-56ed-4e4c-a1bf-3df3c5ea0a38.png',
    caption: 'Sushi Bake en capas',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tz3fUVgQ8DCDyGMPWxGYLt/edee13a5-de5b-4a47-940a-0d869d1aa56e.png',
    caption: 'Sushi Donuts con molde',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/dh3MbPuaFa3sY2rF4CFr9C/b5a3c58c-0515-4be1-adc1-90fef25df675.png',
    caption: 'Niguiris en cubetera',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/mBb7rVzJERVZZQnFNXpTRa/ca044290-8fa7-4f58-837b-715854aa1042.png',
    caption: 'Cups, Crispy Bites y Tacos',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/9U5erbkdSDSsxZHezyNnG6/791c3c51-c52c-4db2-a5d0-5b9deb326716.png',
    caption: 'Sushi sin pescado crudo',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/wPRN8GSFGr7L9mzWRiVbpm/0d5c0ba5-c648-4705-b35d-ee7c15c62d2d.png',
    caption: 'Combinaciones económicas vs premium',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/eVDYPdsLqbSiVdT11bD9YM/016a67b0-0505-4a85-9146-66d22cd0188f.png',
    caption: 'Las 3 salsas esenciales',
  },
]

/* ------------------------------------------------------------- Bonuses */

export type Bonus = {
  number: string
  title: string
  subtitle: string
  benefits: string[]
  value: string
  image: string
}

export const BONUS_KICKER = 'Tres complementos que eliminan cualquier excusa.'

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Sushi Express',
    subtitle: '15 ideas para antojos con lo que tenés en casa',
    benefits: ['Ingredientes básicos', 'Listas en 5–20 min', 'Formato imprimible'],
    value: '$27',
    image:
      'https://cdn.magicpatterns.com/uploads/cDNNnSrK9nJBHtRPG4o44Y/PAG_MKUP_B1.png',
  },
  {
    number: '02',
    title: 'Menús Sushi Fácil',
    subtitle: '7 menús listos para armar',
    benefits: ['Sin decisión difícil', 'Cantidades para 2/4/6', 'Listas de compra'],
    value: '$37',
    image:
      'https://cdn.magicpatterns.com/uploads/1mnvUGP3csL6HeJTAQKENR/PAG_MKUP_B2.png',
  },
  {
    number: '03',
    title: 'Kit Visual',
    subtitle: 'Presentación premium sin vajilla cara',
    benefits: ['Colores estratégicos', 'Emplatado paso a paso', 'Fotos con celular'],
    value: '$32',
    image:
      'https://cdn.magicpatterns.com/uploads/5VsnEazBnwsP93oDyDEcpg/PAG_MKUP_B3.png',
  },
]

export const BONUS_TOTAL = '$96 USD'

/* --------------------------------------------------------------- Offer */

export const OFFER_NAME = 'Sistema Completo — 90 páginas + 3 bonos'

export const offerItems: string[] = [
  'Ebook principal — 90 páginas, 40+ recetas',
  '7 formatos visuales sin enrollar',
  '3 bonos estratégicos incluidos',
  'Acceso digital en 5 minutos, de por vida',
]

export const pricing = {
  regularPrice: '$97 USD',
  today: '$17',
  afterLaunch: '$47 USD',
  spotsTaken: 72,
  idealFor: 'Cualquiera que quiera sushi espectacular sin técnica',
}

/* ---------------------------------------------------------- Comparison */

export type ComparisonRow = { aspect: string; without: string; with: string }

export const comparisonRows: ComparisonRow[] = [
  { aspect: 'Tiempo', without: '60+ min buscando receta', with: '15 min cocinando' },
  { aspect: 'Ingredientes', without: '¿Qué necesito?', with: 'Lista lista' },
  { aspect: 'Resultado', without: '50/50 si funciona', with: 'Funciona siempre' },
  { aspect: 'Costo mensual', without: '$300+ en delivery', with: '$50 en ingredientes' },
  { aspect: 'Apariencia', without: 'Casero', with: 'Premium' },
]

export const CLOSING_LINE = 'Hoy puede ser diferente.'

export const CLOSING_SUB = 'La siguiente comida puede ser espectacular.'

export const CLOSING_BODY =
  'Tienes todo lo que necesitas para cocinar sushi casero profesional.'

/* ----------------------------------------------------------------- FAQ */

export type Faq = { question: string; answer: string }

export const faqs: Faq[] = [
  {
    question: '¿Funciona si soy principiante?',
    answer:
      'Sí. Instrucciones directas, métodos familiares y cero técnica avanzada. Si sabés cocinar arroz, podés hacer todo lo que hay adentro.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Es 100% PDF. Recibís el acceso en 5 minutos: descargable o en línea, desde el celular, la tablet o la computadora. Acceso de por vida.',
  },
  {
    question: '¿Qué lo hace diferente a las recetas online?',
    answer:
      'Está diseñado SIN esterilla. Usa formatos alternativos (Balls, Bake, Donuts, Crispy, Cups y Tacos) e ingredientes básicos de supermercado. Se ve premium sin complicaciones.',
  },
]

/* -------------------------------------------------------------- Footer */

export const FOOTER_LINE =
  'Sushi viral, fácil y visual. 40+ combinaciones sin enrollar.'

export const footerLinks = {
  email: 'hola@labibliadelsabor.com',
  social: '@labibliadelsabor',
  website: 'La Biblia del Sabor',
}

export type PurchaseNotice = { name: string; location: string; minutesAgo: number }

export const purchaseNotice: PurchaseNotice = {
  name: 'Valentina G.',
  location: 'Buenos Aires',
  minutesAgo: 3,
}
